var exports = {
  "Xe": "FluxerTagChangeModal.module__confirmDescription___aGFZV1",
  "z8": "FluxerTagChangeModal.module__confirmSecondary___aGFZV1",
  "O7": "FluxerTagChangeModal.module__fluxerTagContainer___aGFZV1",
  "To": "FluxerTagChangeModal.module__fluxerTagLabel___aGFZV1",
  "Nr": "FluxerTagChangeModal.module__fluxerTagInputRow___aGFZV1",
  "jo": "FluxerTagChangeModal.module__usernameInput___aGFZV1",
  "me": "FluxerTagChangeModal.module__separator___aGFZV1",
  "vb": "FluxerTagChangeModal.module__discriminatorInput___aGFZV1",
  "xU": "FluxerTagChangeModal.module__discriminatorInputDisabled___aGFZV1",
  "d0": "FluxerTagChangeModal.module__discriminatorOverlay___aGFZV1",
  "Ye": "FluxerTagChangeModal.module__errorBox___aGFZV1",
  "jY": "FluxerTagChangeModal.module__validationBox___aGFZV1",
  "KF": "FluxerTagChangeModal.module__premiumDiscriminatorWarning___aGFZV1",
  "Lu": "FluxerTagChangeModal.module__premiumUpsell___aGFZV1",
};

module.exports = exports;
